import { createWebSocketSendActions, createWebSocketReceiveActions } from './createFetchActions';

const clusterAnalysisSubscribeActions = createWebSocketSendActions('CLUSTER_ANALYSIS_SUBSCRIBE');
const newClusterAnalysisAction = createWebSocketReceiveActions('NEW_CLUSTER_ANALYSIS');

export { clusterAnalysisSubscribeActions, newClusterAnalysisAction };
